import React, { useState, useRef, useEffect } from "react";
import ChatFinePrint from "../../../Common/ChatFinePrint";
import { askQuestion } from "../../../utilities/EmgptUtilities";
const EmGptChatBox = ({
  inUseDocumentIds,
  height,
  maxWidth,
  getPageNumber,
  setPageNumbers,
  chatSuggestions,
}) => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [documentIdInput, setDocumentIdInput] = useState("");
  const messagesEndRef = useRef();

  useEffect(() => {
    const messagesContainer = messagesEndRef.current;
    if (messagesContainer) {
      messagesContainer.scrollTo({
        top: messagesContainer.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages]);

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      askQuestion(
        setIsLoading,
        userInput,
        setUserInput,
        documentIdInput,
        inUseDocumentIds,
        setMessages,
        messages,
        setPageNumbers,
        getPageNumber
      );
    }
  };
  useEffect(() => {
    if (
      inUseDocumentIds &&
      inUseDocumentIds.length === 1 &&
      inUseDocumentIds[0]["document_name"] &&
      messages.length > 1
    ) {
      setMessages((prev) => [
        ...prev,
        {
          type: "info",
          text: `Selected Document : ${inUseDocumentIds[0]["document_name"]}`,
        },
      ]);
    }
  }, [inUseDocumentIds]);

  const handleSuggestionClick = (suggestion) => {
    setUserInput(suggestion);
    askQuestion(
      setIsLoading,
      suggestion,
      setUserInput,
      documentIdInput,
      inUseDocumentIds,
      setMessages,
      messages,
      setPageNumbers,
      getPageNumber
    );
  };
  const ClearChat = () => {
    setMessages([]);
    setUserInput("");
    setDocumentIdInput("");
    setIsLoading(false);
  };
  // const handleDocumentIdChange = (e) => {
  //   setDocumentIdInput(e.target.value); // Function to handle changes in documentId input
  // };

  return (
    <div className="container mt-4 ">
      <div
        className="mb-3"
        id="suggestion_section"
        style={{
          transition: "all 0.8s",
        }}
      >
        <div className="row">
          {chatSuggestions.map((suggestion, index) => (
            <div className="col-6 mb-3" key={index}>
              <button
                key={index}
                className="btn btn-outline-secondary "
                onClick={() => handleSuggestionClick(suggestion)}
                style={{ fontSize: "14px", maxWidth: "100%" }}
              >
                {suggestion}
              </button>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="d-flex justify-content-end align-items-center mb-3">
        <label className="form-label me-2">
          If you have a any specific Document ID to query:
        </label>
        <input
          type="text"
          className="form-control"
          style={{ width: "auto" }}
          placeholder="Enter Document ID"
          value={documentIdInput}
          onChange={handleDocumentIdChange}
        />
      </div> */}
      <div className="card h-100">
        <div className="card-body h-100">
          {messages.length > 0 && (
            <div className="d-flex justify-content-end mb-2">
              <button
                className="btn btn-danger btn-sm"
                onClick={ClearChat}
                disabled={isLoading}
              >
                Reset Chat
              </button>
            </div>
          )}
          <div
            className="messages mb-3 overflow-auto"
            style={{
              height: height ? `${height - 240}px` : "300px",
              transition: "height 0.5s",
            }}
            ref={messagesEndRef}
          >
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`alert ${
                  msg.type === "question"
                    ? "text-right bg-primary text-white"
                    : msg.type === "info"
                    ? "text-center bg-light text-black"
                    : "text-left bg-secondary text-white"
                }`}
                style={{
                  maxWidth: maxWidth ? maxWidth : "80%",
                  margin:
                    msg.type === "question" ? "0 0 10px auto" : "0 auto 10px 0",
                }}
              >
                {msg.text}
              </div>
            ))}
            {isLoading && (
              <div
                className="d-flex justify-content-center align-items-center my-2 text-left bg-light"
                style={{
                  maxWidth: "50%",
                  height: "50px",
                  margin: "0 auto 10px 0",
                }}
              >
                <div className="loading-dot"></div>
                <div className="loading-dot"></div>
                <div className="loading-dot"></div>
              </div>
            )}
          </div>
          <div className="input-group ">
            <input
              type="text"
              className="form-control"
              placeholder="Type your question"
              value={userInput}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />
            <button
              className="btn btn-primary"
              onClick={() =>
                askQuestion(
                  setIsLoading,
                  userInput,
                  setUserInput,
                  documentIdInput,
                  inUseDocumentIds,
                  setMessages,
                  messages,
                  setPageNumbers,
                  getPageNumber
                )
              }
              disabled={isLoading}
            >
              Send
            </button>
          </div>
          <ChatFinePrint
            assistantName="EM GPT"
            variant="light"
            style={{ marginTop: "6px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmGptChatBox;
